<template>
    <a-radio-group v-model="changeValue" style="width: 100%">
        <template v-for="(item, index) in options">
            <a-radio :key="`radio_${index}`" :value="item.value">
                {{ item.label }}
            </a-radio>
        </template>
    </a-radio-group>
</template>

<script>
import { DataEntryMixin } from './mixins';

export default {
    name: 'SdRadio',
    mixins: [DataEntryMixin],
    computed: {
        // 是否可编辑
        isModify({ $props }){
            return Boolean($props.field.isModify);
        },
        options() {
            const sourceData = this.parameters.options || [];
            const options = [];
            sourceData.forEach(item => {
                if (item.isEnable) {
                    options.push(item);
                }
            });
            return options;
        },
    },
    watch: {
        value: {
            handler(){
                this.$emit('refreshForm'); // 报考自定义关联业务
            }
        }
    }
};
</script>

<style scoped lang="scss"></style>
